export default "__VITE_ASSET__0ec4dd27__"